export var backendAPI = "https://globularinfobackend.onrender.com/api"
